import './polyfills/promise';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import initSentry from './sentry';
import firebase from 'firebase/app';
import { firebaseConfig } from '@config';
import loadPolyfills from './polyfills';

try {
  (async () => {
    await loadPolyfills();

    initSentry();

    firebase.initializeApp(firebaseConfig);

    ReactDOM.render(<App />, document.getElementById('root'));
  })();
} catch (error) {
  console.error('Error starting the app: ', error);
}
